import { coreFlightCfarOffersThemeVars } from "@b2bportal/core-flights-cfar-offers";

export const themeVariables = {
  /** Example of how to override a global css variable **/
  /** Primary and secondary colors have to be hexadecimal colors **/
  primary: "#000",
  secondary: "#141414",
  black: "#000",
  white: "#fff",
  divider: "#EDEDED",
  "text-border": "",
  "background-color": "#EDEDED",
  "background-color-light": "#F3F3F3",
  "popup-background-color": "#fff",
  green: "#00847F",
  red: "#A8000B",
  "complimentary-red-2": "#ba1110",
  "blue-background": "#ebeff4",
  blue: "#305a85",
  skyblue: "#305a85",
  "footer-text-color": "#EDEDED",
  "brown-background": "#A87C00",
  "brown-background-2": "#954017",

  /** Other configurations can point to an existing variable **/
  "homepage-title-primary": "var(--primary)",

  /** Example of how to override the font family **/
  "font-family": ["Roboto", "sans-serif"].join(","),

  ////////

  /** Common */
  "text-primary": "#333333",
  "text-secondary": "rgba(103, 104, 104, 1.0)",
  "link-primary": "#008ECC",
  "text-black": "#000",
  error: "#A8000B",

  /** Button */
  "coral-50": "#DB0011",
  "button-primary": "#fff",
  "button-primary-background": "#DB0011",
  "button-primary-hover-background": "#E04846",
  "button-primary-hover": "#fff",
  "button-primary-disabled": "#fff",
  "button-primary-disabled-background": "#d7d7d7",
  "button-secondary": "var(--secondary)",
  "button-secondary-background": "#fff",
  "button-secondary-border": "var(--text-black)",

  border: "#D7D8D6",
  "border-dark": "#767676",
  "border-light": "#F3F3F3",
  "border-selected": "#000",
  "grey-6": "#AAAAAA",

  /** Alert */
  "alert-info-background-color": "#EBEFF4",
  "alert-info-border": "#305A85",

  /** Icon */
  "icon-available": "#00AA00",

  /** Loading */
  "loading-icon-track-color": "transparent",
  "loading-icon-border-color": "#000",
  "loading-background-color": "var(--primary)",
  "loading-text-color": "#fff",

  /** ========= UI ======== */
  "slider-background-color": "rgba(216, 216, 216, 1.0)",
  "slider-range-background-color": "var(--primary)",
  "slider-thumb-background-color": "var(--primary)",
  "slider-thumb-value-background-color": "var(--primary)",
  "slider-thumb-value-color": "#fff",

  "page-header-background-color": "#fff",
  "page-header-text-color": "var(--text-black)",
  "page-footer-background-color": "#000",
  "page-footer-text-color": "#fff",

  "checkbox-border-color": "var(--border)",
  "checkbox-checked-border-color": "var(--primary)",
  "checkbox-checked-background-color": "var(--primary)",
  "checkbox-checked-icon-color": "#fff",

  "input-background-color": "#fff",
  "input-border-color": "var(--border-dark)",
  "input-error-color": "var(--error)",
  "input-error-border-color": "var(--error)",
  "core-color-input-error": "var(--error)",
  "core-color-input-border": "var(--border-dark)",

  "radio-select-border": "1px solid var(--primary)",
  "radio-button-border-color": "var(--border-dark)",
  "core-color__ui__radio-selected": "var(--text-primary)",
  "radio-button-selected-color": "var(--text-primary)",

  "notification-banner-background-color": "#EDEDED",
  "notification-banner-text-color": "var(--text-primary)",

  "notification-banner-warning-background-color": "#FFF8EA",
  "notification-banner-warning-border-color": "#FFBB33",

  /** ========= Flights ======== */
  "flight-list-search-background": "#fff",
  "algomerch-tag-background": "rgba(0, 163, 207, 0.10)",
  "algomerch-tag-text": "#013D58",
  "danger-text": "#CC2427",
  "fare-list-background": "#FBFBFB",
  "selected-fare-background": "#F9F2F3",

  "segment-icon-color": "#CECFCD",
  "segment-layover-color": "#F4F4F4",
  "flight-fare-notice": "rgba(1, 61, 88, 1.0)",
  "flight-fare-option-border": "var(--border)",
  "flight-fare-option-border-selected": "var(--text-primary)",
  "flight-fare-option-selected": "var(--text-primary)",

  "flight-fare-details-more-button-background": "#EFEFEF",

  "flight-loading-background-color": "var(--primary)",
  "flight-loading-text-color": "#fff",

  "flight-card-summary-icon-color": "var(--text-primary)",
  "flight-card-summary-border-color": "#5e5e5e",

  "review-page-header-color": "#fff",
  "review-page-header-background-color": "var(--primary)",
  "inactive-button-icon-color": "#f6f6f6",

  "flight-list-grid-filter-selected-background-color": "var(--primary)",
  "flight-list-grid-filter-selected-color": "#fff",

  // CALENDAR COLORS
  "calendar-labels-background-color": "#DDD",
  "date-selected-text-color": "#FFFFFF",
  "date-hover-text-color": "#FFFFFF",
  "bucket-0-text-color": "#FFFFFF",
  "bucket-1-text-color": "#FFFFFF",
  "bucket-2-text-color": "#FFFFFF",
  "bucket-3-text-color": "#FFFFFF",
  "bucket-0-dot-color": "rgba(0, 129, 64, 1.0)",
  "bucket-1-dot-color": "rgba(240, 160, 42, 1.0)",
  "bucket-2-dot-color": "rgba(227, 102, 36, 1.0)",
  "bucket-3-dot-color": "rgba(204, 36, 39, 1.0)",
  "white-font-color": "rgba(255, 255, 255, 1.0)",
  "grey-font-color": "rgba(80, 80, 80, 1.0)",
  "date-hover-color": "rgba(0, 118, 193, 1.0)",
  "date-selected-color": "rgba(0, 118, 193, 1.0)",
  "date-range-limit-color": "rgba(0, 118, 193, 1.0)",
  "date-disabled-color": "rgba(216, 216, 216, 1.0)",
  "date-selected-background-color": "#fff",

  "flight-search-bar-text-primary": "var(--text-primary)",

  // TRIPS
  "trips-breadcrumbs-color-text": "#fff",
  "trips-heading-color-text": "#fff",

  // PRICE PREDICTION
  "price-prediction-wait": "rgba(199, 1, 22, 1.0)",
  "price-prediction-fair": "rgba(236, 130, 65, 1.0)",
  "price-prediction-good": "rgba(249, 209, 0, 1.0)",
  "price-prediction-great": "rgba(0, 129, 64, 1.0)",

  // PRICE PREDICTION GRADIENT COLORS
  "price-prediction-gradient-wait": "rgba(199, 1, 22, 1.0)",
  "price-prediction-gradient-fair": "rgba(236, 130, 65, 1.0)",
  "price-prediction-gradient-good": "rgba(249, 209, 0, 1.0)",
  "price-prediction-gradient-great": "rgba(0, 129, 64, 1.0)",

  // TRIPS LIB COLORS
  "primary-text": "#141414",
  "secondary-text": "rgba(103, 104, 104, 1.0)",
  "trips-selected-filter-color": "var(primary)",
  "trips-list-background-color": "var(--gray-05)",
  "trips-link-color": "var(--text-primary)",
  "profile-link-color": "var(primary)",
  "secondary-button-background-disabled": "var(--gray-30)",
  "secondary-button-background-hover": "var(--gray-20)",
  "info-details-popup-background": "#F6F6F6",
  "gray-20": "var(--info-details-popup-border)",
  "gray-80": "grey",
  "card-tag-text": "var(--text-primary)",
  "card-tag-background": "var(--secondary)",

  "caution-fill-color": "#FFBB33",
  "pill-error-fill-color": "var(--red)",
  "neutral-fill-color": "var(--background-color)",
  "success-fill-color": "var(--green)",
  "required-tag-fill-color": "#E31E22",

  // CUSTOMER SUPPORT CHAT
  "chat-bg-agent": "var(--background-color)",
  "chat-bg-customer": "#303030",
  "chat-bg-customer-error": "#EAEAEA",
  "chat-bg-fab": "var(--background-color)",
  "chat-bg-fab-hover": "var(--background-color)",
  "chat-control-border-color": "#c9c9c9",
  "chat-divider-color": "#dcdcdc",
  "chat-fab-icon-color": "var(--primary)",
  "chat-message-border-color": "#f0f0f0",
  "chat-text-agent": "rgba(0, 0, 0, 0.92)",
  "chat-text-customer": "var(--background-color)",
  "chat-text-customer-error": "var(--secondary-text)",
  "chat-text-deeplink": "var(--text-primary)",
  "z-modal": 1300,

  "success-tick-color": "#00847F",
  "tripadvisor-green": "#28B67A",

  "tag-yellow": "#FFD700",

  // Flights CFAR
  ...coreFlightCfarOffersThemeVars({
    nonRefundableInfoBarBackgroundColor: "rgba(235, 239, 244, 1)",
    nonRefundableInfoBarIconColor: "#000",
  }),
};
